/**
 * Prevents default behavior of HTML <form> tag on "Enter" key press
 */
export const preventSubmitOnEnter = (evt: React.KeyboardEvent) => {
  if (evt.code === 'Enter') {
    evt.preventDefault()
    evt.stopPropagation()
  }
}
